import * as Yup from "yup"

export const isUnitedStatesCountry = country => {
  const normalized = typeof country === "string" ? country.toLowerCase().replace(/[^a-z]/g, "") : ""
  return ["us", "usa", "unitedstates", "america", "unitedstatesofamerica"].includes(normalized)
}

export const isTrackingNumberRequired = (country, barcode) =>
  isUnitedStatesCountry(country) && !String(barcode || "").trim().toLowerCase().endsWith("pp")

export const trackingNumberSchema = Yup.string()
  .trim()
  .max(120, "Tracking Number must not exceed 120 characters")
  .test("tracking-number-text", "Tracking Number must be text", function () {
    return this.originalValue === undefined || typeof this.originalValue === "string"
  })
  .test("tracking-number-required", "Tracking Number is required for U.S. REG and EXP tests", function (value) {
    return !isTrackingNumberRequired(this.parent.country, this.parent.barcode) || Boolean(value)
  })
  .label("Tracking Number")
